import React from "react";
import "./home-landing.css";

const AREAS = ["Practical life", "Sensorial", "Language", "Mathematics", "Culture"];

// Slanted band of the five Montessori areas of work, scrolling forever.
const MarqueeStrip = () => {
  const items = [...AREAS, ...AREAS, ...AREAS, ...AREAS];
  return (
    <div className="lh-marquee" aria-label="Montessori areas of work">
      <div className="lh-marquee__track" aria-hidden="true">
        {items.map((label, i) => (
          <span className="lh-marquee__item" key={`${label}-${i}`}>
            {label}
            <em>✱</em>
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeStrip;
